export class CurrencyDecimals {
    // Mirrors server CurrencyExchangeService.getCurrencyDecimals().
    // NOTE: Any changes to server-side currency precision rules should be reflected here.
    static getCurrencyDecimals(currencyType?: string, currency?: string): number {
        // Tournament play-chips are integer units.
        if (currencyType === 'tournament_chips') return 0;

        const code = String(currency || '').trim().toUpperCase();
        if (!code) return 2;

        const decimalMap: Record<string, number> = {
            USD: 2,
            USDT: 2,
            USDC: 2,
            BUSD: 2,
            DAI: 2,

            // Tournament play-chips should be integer units (industry standard).
            // This prevents fractional "chip" balances (e.g. 3833.5) which break exact bet sizing (all-in).
            CHIPS: 0,

            DOGE: 6,
            SOLAMA: 6,
            DOT: 6,
            BNB: 8,
            XMR: 12,
            SHIB: 8,
            VLX: 8,
        };

        return decimalMap[code] ?? 2;
    }
}

